export const AB_TESTS_KNOWLEDGE_BASE_URL =
  'https://knowledge-base.yieldbird.com/yieldbird-platform/ab-testing' as const
